<template>
  <div>
    <script :id="id"
            type="text/plain"></script>
    <!-- <Modal
        v-model="modal4"
        title="选择内置模板"
        width="735"
        >
        <ul class="post-template-ul" style="height:380px">
          <li class="post-template-li thisview">
            <div class="template-list-pic">
              <img class="template-list-img" src="http://img.sys.hudongba.com/static_v4/images/post/post_template_img01.jpg">
              <p class="template-list-title">互联网创投峰会模板</p>
            </div>
          </li>
          <li class="post-template-li thisview">
            <div class="template-list-pic">
              <img class="template-list-img" src="http://img.sys.hudongba.com/static_v4/images/post/post_template_img01.jpg">
              <p class="template-list-title">互联网创投峰会模板</p>
            </div>
          </li>
          <li class="post-template-li thisview">
            <div class="template-list-pic">
              <img class="template-list-img" src="http://img.sys.hudongba.com/static_v4/images/post/post_template_img01.jpg">
              <p class="template-list-title">互联网创投峰会模板</p>
            </div>
          </li>
          <li class="post-template-li thisview">
            <div class="template-list-pic">
              <img class="template-list-img" src="http://img.sys.hudongba.com/static_v4/images/post/post_template_img01.jpg">
              <p class="template-list-title">互联网创投峰会模板</p>
            </div>
          </li>
        </ul>
        <div slot="footer" style="text-align:center">
            <Page :total="45" />
        </div>
    </Modal> -->
  </div>
</template>
<script>
import baseUrl from "@/config/index"
export default {
  name: "UEDITOR",
  data () {
    return {
      modal4: false,
      id: this.generatorOnlyId(),
      editor: null,
      tempIndex: -1,
      tempimages: [
        {
          path:
            "http://img2.hudongba.com/static_v4/images/post/poster_image_yundong_04.jpg@!poster_image_preview",
          id: 575
        },
        {
          path:
            "http://img2.hudongba.com/static_v4/images/post/poster_image_yundong_08.jpg@!poster_image_preview",
          id: 576
        },
        {
          path:
            "http://img2.hudongba.com/static_v4/images/post/poster_image_yundong_08.jpg@!poster_image_preview",
          id: 577
        }
      ]
    };
  },
  props: {
    defaultMsg: {
      type: String,
      default: ""
    },
    config: {
      type: Object
    }
  },
  mounted () {

    const _this = this;
    this.config.serverUrl = baseUrl + "ueditor"
    this.editor = UE.getEditor(this.id, this.config); // 初始化UE
    this.setUEContent(this.defaultMsg)
    // UE.commands["watermark"] = {
    //   execCommand: function() {
    //     _this.modal4 = true;
    //   },
    //   // execCommand: function() {
    //   //   this.execCommand(
    //   //     "insertHtml",
    //   //     '<a href="http://blog.csdn.net/zzq900503">张小凡的水印</a>'
    //   //   );
    //   //   return true;
    //   // },
    //   queryCommandState: function() {}
    // };
  },
  methods: {
    // 生成唯一ID
    generatorOnlyId () {
      return (
        this.$moment().format("YYYYMMDDHHmmssSSS") +
        Math.floor(Math.random() * 10000)
      );
    },
    getUEContent () {
      // 获取内容方法
      return this.editor.getContent();
    },
    setUEContent (msg) {
      let self = this, setResult = null;
      this.editor.ready(function () {
        setResult = self.editor.setContent(msg);
      });
      return setResult;
    },
    ok () {
      this.$Message.info("Clicked ok");
    },
    cancel () {
      this.$Message.info("Clicked cancel");
    }
  },
  watch: {
    defaultMsg: function (newMsg, oldMsg) {
      this.setUEContent(newMsg);
    },
  },
  destroyed () {
    this.editor.destroy();
  }
};
</script>

<style scoped>
.post-template-li {
  display: none;
  width: 160px;
  overflow: hidden;
  float: left;
  margin-right: 15px;
}
.post-template-li.thisview {
  display: block;
}
.post-template-li .template-list-pic {
  width: 160px;
  height: 373px;
  border: 1px solid #ddd;
  position: relative;
  cursor: pointer;
}
.post-template-li .template-list-pic img {
  width: 158px;
  height: 373px;
}
.post-template-li .template-list-pic .template-list-title {
  height: 30px;
  line-height: 30px;
  width: 160px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  bottom: 0;
  color: #fff;
  padding: 0 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ueditor.vue